import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { SingleDatePicker } from "react-dates";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import Card from "views/universal/Components/Card";

/**
 * Filtre optionnel sur l'heure de passage de commande (ordered_at).
 * Se cumule avec la période de livraison : ex. commandes livrées le 10 août
 * ET passées avant le 10 août à 09:00.
 *
 * La valeur est un objet {date: moment|null, time: 'HH:mm'}. Le filtre n'est
 * envoyé à l'API que lorsque la date ET l'heure sont renseignées.
 */
const OrderedBeforeFilter = (props) => {

  const { value, onChange, idPrefix, defaultDate } = props;

  const [focused, setFocused] = useState(false);

  const date = value && value.date ? value.date : null;
  const time = value && value.time ? value.time : '';

  const handleDate = (newDate) => {
    onChange({ date: newDate, time });
  };

  const handleTime = (newTime) => {
    // Confort : si on saisit une heure sans avoir choisi de date, on préremplit
    // avec la date de début de livraison (cas courant : même jour).
    const nextDate = (!date && newTime && defaultDate) ? moment(defaultDate) : date;
    onChange({ date: nextDate, time: newTime });
  };

  const incomplete = (date && !time) || (!date && time);

  return (
    <Card title="Commandé avant le" description="" icon={faClock} colorIcon={'#abd156'}>
      <div className="d-flex align-items-center flex-wrap" style={{ gap: '8px' }}>
        <SingleDatePicker
          date={date}
          onDateChange={handleDate}
          focused={focused}
          onFocusChange={({ focused }) => setFocused(focused)}
          id={`${idPrefix}_ordered_before_date`}
          numberOfMonths={1}
          isOutsideRange={() => false}
          displayFormat={"DD MM YYYY"}
          placeholder="Date"
          showClearDate
          small
        />
        <Form.Control
          type="time"
          value={time}
          onChange={(e) => handleTime(e.target.value)}
          style={{ maxWidth: '130px' }}
        />
      </div>
      {incomplete
        ? <small className="text-danger d-block mt-2">Renseignez la date et l'heure, ou videz les deux pour désactiver ce filtre.</small>
        : <small className="text-muted d-block mt-2">Optionnel : ne garde que les commandes passées avant ce moment.</small>
      }
    </Card>
  );
};

/**
 * Sérialise la valeur du filtre pour l'API (format yyyy-mm-dd hh:mm).
 * Retourne null si le filtre est inactif ou incomplet.
 */
export const formatOrderedBefore = (value) => {
  if (!value || !value.date || !value.time) {
    return null;
  }
  return `${moment(value.date).format("YYYY-MM-DD")} ${value.time}`;
};

/**
 * true si le filtre est à moitié renseigné (date sans heure ou l'inverse).
 */
export const isOrderedBeforeIncomplete = (value) => {
  if (!value) {
    return false;
  }
  return (!!value.date && !value.time) || (!value.date && !!value.time);
};

OrderedBeforeFilter.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  idPrefix: PropTypes.string.isRequired,
  defaultDate: PropTypes.object
};

OrderedBeforeFilter.defaultProps = {
  value: { date: null, time: '' },
  defaultDate: null
};

export default OrderedBeforeFilter;
